import React, { useState, useEffect } from "react";
import "./Budget.css";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../firebase";
import { collection, doc, query, where, getDocs, updateDoc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const Budget = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/");
    }
  }, []);

  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [actionPlan, setActionPlan] = useState([]);
  const [demands, setDemands] = useState({});
  const [budgetData, setBudgetData] = useState({
    ageneral: 0,
    ascsp: 0,
    anicra: 0,
    acfldo: 0,
    acfldp: 0,
    anf: 0,
    asponsored: 0,
    anabard: 0,
    aarya: 0,
    aosmv: 0,
    aseedhub: 0,
    aatma: 0,
    auniversity: 0,
    ugeneral: 0,
    uscsp: 0,
    unicra: 0,
    ucfldo: 0,
    ucfldp: 0,
    unf: 0,
    usponsored: 0,
    unabard: 0,
    uarya: 0,
    uosmv: 0,
    useedhub: 0,
    uatma: 0,
    uuniversity: 0,
    bgeneral: 0,
    bscsp: 0,
    bnicra: 0,
    bcfldo: 0,
    bcfldp: 0,
    bnf: 0,
    bsponsored: 0,
    bnabard: 0,
    barya: 0,
    bosmv: 0,
    bseedhub: 0,
    batma: 0,
    buniversity: 0,
  });

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");

  const fetchBudgetData = async () => {
    try {
      const budgetRef = doc(db, "empmaster", empId, String(document.getElementById("dd3").value), "budget");
      const docSnap = await getDoc(budgetRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setBudgetData({
          ageneral: data.ageneral || 0,
          ascsp: data.ascsp || 0,
          anicra: data.anicra || 0,
          acfldo: data.acfldo || 0,
          acfldp: data.acfldp || 0,
          anf: data.anf || 0,
          asponsored: data.asponsored || 0,
          anabard: data.anabard || 0,
          aarya: data.aarya || 0,
          aosmv: data.aosmv || 0,
          aseedhub: data.aseedhub || 0,
          aatma: data.aatma || 0,
          auniversity: data.auniversity || 0,
          ugeneral: data.ugeneral || 0,
          uscsp: data.uscsp || 0,
          unicra: data.unicra || 0,
          ucfldo: data.ucfldo || 0,
          ucfldp: data.ucfldp || 0,
          unf: data.unf || 0,
          usponsored: data.usponsored || 0,
          unabard: data.unabard || 0,
          uarya: data.uarya || 0,
          uosmv: data.uosmv || 0,
          useedhub: data.useedhub || 0,
          uatma: data.uatma || 0,
          uuniversity: data.uuniversity || 0,
          bgeneral: data.bgeneral || 0,
          bscsp: data.bscsp || 0,
          bnicra: data.bnicra || 0,
          bcfldo: data.bcfldo || 0,
          bcfldp: data.bcfldp || 0,
          bnf: data.bnf || 0,
          bsponsored: data.bsponsored || 0,
          bnabard: data.bnabard || 0,
          barya: data.barya || 0,
          bosmv: data.bosmv || 0,
          bseedhub: data.bseedhub || 0,
          batma: data.batma || 0,
          buniversity: data.buniversity || 0,
        });
      } else {
        console.log("No budget data found.");
      }
    } catch (error) {
      console.error("Error fetching budget data:", error);
    }
  };

  function fy(month, year) {
    const y = parseInt(year);
    if (month === "January" || month === "February" || month === "March") {
      return String(y - 1 + "-" + y % 1000);
    } else {
      return String(y + "-" + parseInt(y % 1000 + 1));
    }
  }

  useEffect(() => {
    if (!month) return;

    const fetchActionPlan = async () => {
      try {
        const q = query(
          collection(db, "actionplan"),
          where("empid", "==", empId),
          where("month", "==", String(month + " " + year))
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          setActionPlan([]);
          setDemands({});
          return;
        }

        const actions = [];
        const demandsObj = {};

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const id = doc.id;

          const demandDate = data.demanddate?.toDate
            ? data.demanddate.toDate().toLocaleDateString("en-GB")
            : "N/A";

          actions.push({
            td:data.td || "",
            id: id,
            supportdoc: data.supportdoc || "",
            accremarks: "Fund is available",
            accdate:demandDate,
            notesheettype: "special",
            code: data.programCode || "",
            text: data.program || "",
            budgetApproved: data.budgetapproved || 0,
            currentstatus: data.currentstatus || "Not Placed",
            demanddate: demandDate,
            budgetDemand: data.budgetdemand || "",
            budgethead: data.budgethead || "",
            totamount: data.totamount || "",
            ddodate: data.ddodate || "",
          });

          demandsObj[id] = {
            td:data.td || "",
            notesheettype: "special",
            accremarks: "Fund is available",
            accdate:demandDate,
            supportdoc: data.supportdoc || "",
            amount: data.budgetdemand || "",
            totamount: data.totamount || "",
            placed: !!data.budgetdemand,
            currentstatus: data.currentstatus || "Not Placed",
            demanddate: demandDate,
            budgethead: data.budgethead || "",
            ddodate: data.ddodate || "",
          };
        });

        setActionPlan(actions);
        setDemands(demandsObj);
      } catch (error) {
        console.error("Error fetching action plans:", error);
      }
    };

    fetchActionPlan();
  }, [month, year]);

  const handleFileUpload = async (index, file) => {
    if (!file) return;

    const fileRef = ref(storage, `uploads/${empId}/${month}_${year}/supportdoc_${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);

    const updatedActions = [...actionPlan];
    updatedActions[index].supportdoc = fileURL;
    setActionPlan(updatedActions);

    return fileURL;
  };

  const handleDemandPlace = async (id) => {
    const budgetText = demands[id]?.amount.trim();
    const mytd = demands[id]?.td;
    const totAmount = parseFloat(demands[id]?.totamount);
   

    try {
      const actionRef = doc(db, "actionplan", id);
      await updateDoc(actionRef, {
        accremarks: "Fund is available",
        td: mytd,
        accdate: new Date(),
        budgetdemand: budgetText,
        totamount: totAmount,
        currentstatus: "Forwarded to DDO",
        demanddate: new Date(),
        notesheettype: "special",
        finalapproval: "No"
      });


      const updatedDemands = { ...demands };
      updatedDemands[id].placed = true;
      updatedDemands[id].currentstatus = "Forwarded to DDO";
      updatedDemands[id].demanddate = new Date().toLocaleDateString("en-GB");
      setDemands(updatedDemands);
    } catch (error) {
      console.error("Error updating budget demand and totals:", error);
    }
  };
  const handleBack =(e)=>{
    e.preventDefault();
    navigate(-1)
  }
  return (
    <div className="container">
      <h1 className="welcome">Administrative & Financial Proposal of {name || "User"}</h1>
      <center>
        <select
          className="dropdown"
          id="dd3"
          onChange={(e) => fetchBudgetData(e.target.value)}
          style={{ width: "300px", height: "40px", marginTop: "0px" }}
        >
          <option value="">Select Financial Year</option>
          {["2024-25", "2025-26", "2026-27", "2027-28"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </center>
      <table className="budget-table">
        <thead>
          <tr>
            <th>Budget</th>
            <th>General</th>
            <th>SCSP</th>
            <th>NICRA</th>
            <th>CFLD(O)</th>
            <th>CFLD(P)</th>
            <th>Natural Farming</th>
            <th>Sponsored Program</th>
            <th>NABARD</th>
            <th>ARYA</th>
            <th>OSMV</th>
            <th>Seed Hub</th>
            <th>ATMA</th>
            <th>Others</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Allocation</td>
            <td>{budgetData.ageneral}</td>
            <td>{budgetData.ascsp}</td>
            <td>{budgetData.anicra}</td>
            <td>{budgetData.acfldo}</td>
            <td>{budgetData.acfldp}</td>
            <td>{budgetData.anf}</td>
            <td>{budgetData.asponsored}</td>
            <td>{budgetData.anabard}</td>
            <td>{budgetData.aarya}</td>
            <td>{budgetData.aosmv}</td>
            <td>{budgetData.aseedhub}</td>
            <td>{budgetData.aatma}</td>
            <td>{budgetData.auniversity}</td>
          </tr>
          <tr>
            <td>Utilized</td>
            <td>{budgetData.ugeneral}</td>
            <td>{budgetData.uscsp}</td>
            <td>{budgetData.unicra}</td>
            <td>{budgetData.ucfldo}</td>
            <td>{budgetData.ucfldp}</td>
            <td>{budgetData.unf}</td>
            <td>{budgetData.usponsored}</td>
            <td>{budgetData.unabard}</td>
            <td>{budgetData.uarya}</td>
            <td>{budgetData.uosmv}</td>
            <td>{budgetData.useedhub}</td>
            <td>{budgetData.uatma}</td>
            <td>{budgetData.uuniversity}</td>
          </tr>
          <tr>
            <td>Balance</td>
            <td>{budgetData.ageneral - budgetData.ugeneral}</td>
            <td>{budgetData.ascsp - budgetData.uscsp}</td>
            <td>{budgetData.anicra - budgetData.unicra}</td>
            <td>{budgetData.acfldo - budgetData.ucfldo}</td>
            <td>{budgetData.acfldp - budgetData.ucfldp}</td>
            <td>{budgetData.anf - budgetData.unf}</td>
            <td>{budgetData.asponsored - budgetData.usponsored}</td>
            <td>{budgetData.anabard - budgetData.unabard}</td>
            <td>{budgetData.aarya - budgetData.uarya}</td>
            <td>{budgetData.aosmv - budgetData.uosmv}</td>
            <td>{budgetData.aseedhub - budgetData.useedhub}</td>
            <td>{budgetData.aatma - budgetData.uatma}</td>
            <td>{budgetData.auniversity - budgetData.uuniversity}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label className="label">Select Month and Year:</label>
          <select
            className="dropdown"
            id="dd1"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
          >
            <option value="">Month</option>
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        <select
          className="dropdown"
          id="dd2"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          style={{ width: "150px", height: "40px", marginTop: "33px" }}
        >
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {actionPlan.length > 0 && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th>Budget Head</th>
                <th>Program Code</th>
                <th>Program Name</th>
                <th>Supporting Document</th>
                <th>Technical Details and <br />Budget Demand</th>
                <th>Current Status/Approved Amount</th>
              </tr>
            </thead>
            <tbody>
              {actionPlan.map((action, index) => (
                <tr key={action.id}>
                  <td>{action.budgethead}</td>
                  <td>{action.code}</td>
                  <td>{action.text}</td>
                  <td>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx"
                      style={{ width: "100px" }}
                      onChange={async (e) => {
                        const fileURL = await handleFileUpload(index, e.target.files[0]);
                        if (fileURL) {
                          try {
                            const actionRef = doc(db, "actionplan", action.id);
                            await updateDoc(actionRef, { supportdoc: fileURL });
                          } catch (error) {
                            console.error("Error updating supportdoc:", error);
                          }
                        }
                      }}
                      disabled={action.supportdoc}
                    /><br />
                    {action.supportdoc && (
                      <a href={action.supportdoc} target="_blank" rel="noopener noreferrer">
                        View Document
                      </a>
                    )}
                  </td>
                  <td>
                    <textarea
                      rows="4"
                      className="textarea-box"
                      placeholder="Write Technical Details"
                      maxLength={750}
                      value={demands[action.id]?.td || ""}
                      onChange={(e) => {
                        const updatedDemands = { ...demands };
                        updatedDemands[action.id].td = e.target.value;
                        setDemands(updatedDemands);
                      }}
                      disabled={demands[action.id]?.placed}
                    />
                    <textarea
                      rows="4"
                      className="textarea-box"
                      placeholder="Write Budget Breakup"
                      maxLength={750}
                      value={demands[action.id]?.amount || ""}
                      onChange={(e) => {
                        const updatedDemands = { ...demands };
                        updatedDemands[action.id].amount = e.target.value;
                        setDemands(updatedDemands);
                      }}
                      disabled={demands[action.id]?.placed}
                    />
                    <input
                      type="number"
                      placeholder="Total Amount (Only Number)"
                      value={demands[action.id]?.totamount || ""}
                      onChange={(e) => {
                        const updatedDemands = { ...demands };
                        updatedDemands[action.id].totamount = e.target.value;
                        setDemands(updatedDemands);
                      }}
                      disabled={demands[action.id]?.placed}
                      className="textarea-box"
                    />
                    {!demands[action.id]?.placed && (
                      <button
                        className="place-btn full-width"
                        onClick={() => handleDemandPlace(action.id)}
                      >
                        Place Demand
                      </button>
                    )}
                    {demands[action.id]?.placed && (
                      <h4 style={{ color: "green" }}>
                        Demand Placed on {demands[action.id]?.demanddate}
                      </h4>
                    )}
                  </td>
                  <td id="mycs">{demands[action.id]?.currentstatus}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
              <img src="/assets/back.png" style={{ width: '100px'}} onClick={handleBack} alt="" />

    </div>
  );
};

export default Budget;